import { useSelector } from "react-redux";
import SkeletonCard from "../../components/skeletonCampaignCard";
import { useCampaignList } from "../reuseableEffects";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import CompletedCampaignCard from "./reuseableComponents/completedCampaignCard";

const CompletedCampaignSummary = () => {
  const loading = useSelector((state) => state.user.loading);
  const campaignList = useCampaignList();
  const campaignImageURL = "https://mosquepay.org/mosquepaynew/assets/img/campaigns/";

  const [slicedCompletedCampaigns, setSlicedCompletedCampaigns] = useState([]);

  useEffect(() => {
    const completedCampaigns = campaignList.filter(campaign => campaign.admin_status === "4");
    setSlicedCompletedCampaigns(completedCampaigns.slice(0, 4));
  }, [campaignList]);

  return (
    <div>
      {loading ? (
        <SkeletonCard />
      ) : (
        <div className="py-4 px-4 md:px-12 grid gap-4">
          <p className="font-semibold text-sm ubuntu-font">
            Completed campaigns:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-10">
            {slicedCompletedCampaigns.map((row, index) => {
              const formattedAmountRaised = parseFloat(row?.amount_raise?.replace(/,/g, "")) || 0;
              const formattedAmount = parseFloat(row?.amount?.replace(/,/g, "")) || 0;
              const progress =
                formattedAmount > 0
                      ? `${(
                          (formattedAmountRaised / formattedAmount) *
                          100
                        ).toFixed(2)}%`
                      : "0%";
              return (
                <CompletedCampaignCard
                  key={index}
                  campaignImage={
                    campaignImageURL + (row?.image || "default-image.png")
                  }
                  campaignID={row?.CampaignID}
                  campaignTitle={row?.title}
                  campaignOwnerFirstName={row?.firstname}
                  campaignOwnerLastName={row?.lastname}
                  amountRaised={row?.amount_raise}
                  campaignGoal={row?.amount}
                  category={row?.category}
                  progress={progress}
                />
              );
            })}
          </div>
          <Link
            to={"/completed-campaigns"}
            className="bg-black text-white text-center md:w-fit text-sm font-medium py-6 px-8 md:py-4 rounded mt-10"
          >
            View all completed campaigns
          </Link>
        </div>
      )}
    </div>
  );
};

export default CompletedCampaignSummary;
